import {createContext} from 'react';

const LogedContext = createContext();

export default LogedContext;